import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    root: {
      width: '100%'
    },
    tableWrapper: {
      overflowX: 'auto'
    },
    table: {
      minWidth: 1000
    },
    toolbar: {
      justifyContent: 'space-between'
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 80
    },

    filters: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'flex-end',
    },
    pagination: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'flex-end',
    }
  };
});

export default styled;
